import React from "react";
import "../../styles/policy.css";
import { NewFooter } from "../../components/newFooter";

export const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacyContain">
        <div className="policySectionMargin">
          <h2 className="text-al">Privacy Policy</h2>

          <p className="text-dm">
            <span>Last updated: January 18, 2023</span>
          </p>
          <p className="text-dm">
            Elana, Inc. (“Elana”, “us”, “we”, or “our”) operates the{" "}
            <a href="https://elana.health">https://elana.health</a> website (the
            “Service”).
          </p>

          <p className="text-dm">
            Recognizing you care how information about you is collected, used,
            shared, and protected, this page informs you of our policies
            regarding such collection, use and disclosure of Personal
            Information (as defined below) when you use our Service. We will not
            use or share your information with anyone except as described in
            this Privacy Policy.
          </p>
          <p className="text-dm">
            We use your Personal Information for providing and improving the
            Service. By using the Service, either as a paid Member or other
            user, you agree to the collection and use of information in
            accordance with this policy. As such, it is essential to understand
            that by using the Elana Site and Service, you consent to the
            collection, storage, sharing, and use of your information as
            described in this Policy. For that reason, it is important you read
            this Policy carefully. If you do not accept the terms of this Policy
            and the referenced documents, do not continue using the Website.
            Unless otherwise defined in this Privacy Policy, terms used in this
            Privacy Policy have the same meanings as in our Terms and
            Conditions, accessible at{" "}
            <a href="https://www.elana.health/terms">
              https://www.elana.health/terms
            </a>
            .
          </p>
          <p className="text-dm">This Policy outlines:</p>
          <p className="text-dm policyOutlineMargin">
            {" "}
            <span className="text-dark ms-1">-1</span> {"  "}What Information We
            Collect About You
          </p>
          <p className="text-dm policyOutlineMargin">
            <span className="text-dark">-2</span> How We Use and Share that
            Information
          </p>
          <p className="text-dm policyOutlineMargin">
            <span className="text-dark">-3</span> How We Protect Your
            Information and How You Can Help
          </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Information Collection And Use </h3>
        <p className="text-dm">
          While using our Service, we may ask you to provide, or you may choose
          to provide, us with certain personally identifiable information that
          can be used to contact or identify you. Some types of personal data
          and information we gather includes: information you provide us,
          information we receive automatically when you interact with the Elana
          Site, data from marketing and other communications, transaction and
          payment information, information from your mobile device, and
          information from other sources. Some of the personally identifiable
          information (“Personal Information”) we collect may include, but is
          not limited to:
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Information Collected from Members</h3>
        <p className="text-dm mb-1">Contact information Name</p>
        <p className="text-dm mb-1">Email </p>
        <p className="text-dm mb-1">Ethnicity</p>
        <p className="text-dm mb-1">Level of education</p>
        <p className="text-dm  mb-1">Location</p>
        <p className="text-dm  mb-1">Care preferences</p>
        <p className="text-dm  mb-1">
          Your preferences for having labs, medication, and/or supplements
          prescribed by your provider{" "}
        </p>
        <p className="text-dm  mb-1">Your provider type preferences</p>
        <p className="text-dm  mb-1">Your communication style preferences</p>
        <p className="text-dm  mb-1">
          Your preference for conventional vs. holistic care{" "}
        </p>
        <p className="text-dm  mb-1">Your treatment preferences</p>
        <p className="text-dm  mb-1">Your specialty preferences</p>
        <p className="text-dm  mb-1">Your provider gender preferences </p>
        <p className="text-dm  mb-1">Your budget</p>
        <p className="text-dm  mb-1">
          Data related to your symptoms and how you are feeling
        </p>

        <p className="text-dm">
          We reserve the right to share some of your relevant information with
          the Providers that you “match” with upon completing our quiz, as the
          intent of Elana is to facilitate introductions between our Members and
          women’s health specialists.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Log Data</h3>
        <p className="text-dm">
          We collect information that your browser sends whenever you visit our
          Service (“Log Data”). This Log Data may include information such as
          your computer’s Internet Protocol (“IP”) address, browser type,
          browser version, the pages of our Service that you visit, the time and
          date of your visit, the time spent on those pages and other
          statistics.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Cookies</h3>
        <p className="text-dm">
          Cookies are files with a small amount of data, which may include an
          anonymous unique identifier. Cookies are sent to your browser from a
          web site and stored on your computer’s hard drive.{" "}
        </p>
        <p className="text-dm">
          We use “cookies” to collect information. You can instruct your browser
          to refuse all cookies or to indicate when a cookie is being sent.
          However, if you do not accept cookies, you may not be able to use some
          portions of our Service.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">How Elana Uses and Shares Information </h3>
        <p className="text-dm">
          In the spirit of recent regulations, Elana recognizes it is important
          you know how we plan to use your personal data. By using the Site and
          accepting Services, you agree that we may use and share your
          information (including aggregate and anonymized information) as
          follows:
        </p>
        <p className="text-dm">
          Improve User Experience: We may monitor and analyze activity, metrics,
          and trends, and use your information to provide services, facilitate
          payments, create new feature or data-related products and service
          offerings, or to learn how the Site is used; to develop, maintain, and
          improve your user experience; to understand how you use the Site and
          to deliver relevant content to you; to streamline the Site by storing
          your access credentials and log file; and to make suggestions and
          provide a customized experience via research and development,
          marketing and advertising; to fix technical errors, update the Site,
          and other internal operations; and to communicate with you.
        </p>
        <p className="text-dm">
          Third Party Service Providers: We may employ third parties to perform
          functions on our behalf. Such third parties may have access to
          information needed to perform their functions, but are not authorized
          to use it for other purposes. We do not provide any of your non-public
          information (such as payment information, password details, or your IP
          address) to third parties without your consent, unless required by
          law.
        </p>
        <p className="text-dm">
          Protection of Elana and Others: We will use collected information to
          enhance the safety and security of the Site and our users. In
          addition, we reserve the right to disclose information when we believe
          that doing so is reasonably necessary to comply with the law or law
          enforcement, to prevent fraud or abuse, or to protect Elana’s rights.
        </p>
        <p className="text-dm">
          In a Merger or Sale: Your information may be shared as a company asset
          in the event of a potential sale, merger, acquisition, or other change
          of ownership or control, whether in part or whole.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">
          How Elana Protects Your Information and How You Can Help
        </h3>
        </div>
        <div className="policySectionMargin">
        <h4 className="text-al">Security</h4>
        <p className="text-dm">
          The security of your Personal Information is important to us, but
          remember that no method of transmission over the Internet, or method
          of electronic storage is 100% secure. While we use commercially
          acceptable means to protect your Personal Information, we cannot
          guarantee its absolute security. One way you can help reduce security
          risk is by keeping your login credentials and account information
          secure and confidential. If you have any reason to believe the
          security of your account has been compromised, notify us immediately
          using the contact information at the bottom of this Policy.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Links To Other Sites</h3>
        <p className="text-dm">
          Our Service may contain links to other sites that are not operated by
          us. If you click on a third party link, you will be directed to that
          third party’s site. We strongly advise you to review the Privacy
          Policy of every site you visit.
        </p>
        <p className="text-dm">
          We have no control over, and assume no responsibility for the content,
          privacy policies or practices of any third party sites or services.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Children’s Privacy</h3>
        <p className="text-dm">
          Our Service is intended for people over the age of 18. We do not
          knowingly collect personally identifiable information from anyone
          under 18 except as specifically authorized in the Elana Terms and
          Conditions. If you are a parent or guardian and you are aware that
          your child has provided us with Personal Information in violation or
          breach of our Terms and Conditions, contact us immediately. If we
          discover that a child under 18 has provided us with Personal
          Information, we will delete such information from our servers
          immediately.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Compliance With Laws</h3>
        <p className="text-dm">
          We will disclose your Personal Information where required to do so by
          law or subpoena.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Changes To This Privacy Policy</h3>
        <p className="text-dm">
          We may update our Privacy Policy from time to time. We will notify you
          of any changes by posting the new Privacy Policy on this page, which
          will include a version date at the top. You are advised to review this
          Privacy Policy periodically for any changes. Changes to this Privacy
          Policy are effective when they are posted on this page. If at any
          point, you do not agree to the terms of our Privacy Policy, you can
          close your Member account.
        </p>
        </div>
        <div className="policySectionMargin">
        <h3 className="text-al">Additional Rights and How to Contact Us</h3>
        <p className="text-dm">
          We have appointed a data privacy manager who is responsible for
          overseeing questions in relation to this Privacy Policy. If you have
          any questions about this Policy, including any requests to exercise
          your legal rights, please contact the data privacy manager by
          emailing:{" "}
          <a href="mailto:hello@elana.health?subject=Privacy Manager">
            hello@elana.health
          </a>
          , attention: Privacy Manager
        </p>
        <p className="fs-16-12 py-4 text-center text-dm">
          Disclaimer: The information provided through Elana Health website and
          services is not intended or
          <br className="mobile-view-hidden" />
          implied to be a substitute for professional medical advice, diagnosis
          or treatment.
        </p>
        </div>
      </div>
      <NewFooter />
    </>
  );
};
